import {
  Component,
  forwardRef,
  Inject,
  Input
}                           from '@angular/core';
import {
  BlockUI,
  NgBlockUI
}                           from 'ng-block-ui';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { BigDecimalService }           from '../core/services/big-decimal.service';
import { HaynesProLookupsQuoteModel }  from './typings/haynes-pro.lookups.quote';
import { HaynesProService }            from './haynes-pro.service';
import { IntegrationQuotePricesModel } from '../integrations/typings/integration.quote-prices';
import { MessagesService }             from '../messages/messages.service';

@Component({
  selector   : 'wor-haynes-pro-purchase-lookups',
  template: require('./haynes-pro.purchase-lookups.component.html')
})
export class HaynesProPurchaseLookupsComponent {
  public quote: HaynesProLookupsQuoteModel = {};

  @BlockUI('haynesProPurchaseLookupsBlock') block : NgBlockUI;

  @Input() prices : IntegrationQuotePricesModel;

  constructor (
    public activeModal        : NgbActiveModal,
    @Inject(forwardRef(() => BigDecimalService)) private bigDecimalService : BigDecimalService,
    @Inject(forwardRef(() => HaynesProService))
    public haynesProService   : HaynesProService,
    @Inject(forwardRef(() => MessagesService)) private messagesService   : MessagesService,
    public translateService   : TranslateService
  ) {}

  confirm () : void {
    this.block.start();

    this.haynesProService.confirmLookupPurchase(this.quote.quantity)
    .then(() => {
      this.activeModal.close();
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  getCurrentPrice () {
    return this.haynesProService.getCurrentPrice(this.quote.quantity, this.prices);
  };

  getLabel ( form : NgForm ) : string {
    if ( this.quote.quantity < 100 || form?.controls?.quantity?.invalid && form?.controls?.quantity?.dirty ) {
      return this.translateService.instant('GENERAL_SPACE.ERROR_MESSAGE.INVALID_QUANTITY');
    }
    else {
      return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.NUMBER_OF_REQUESTS');
    }
  }

  updatePrice ( quantity : number ) : void {
    const hundred = this.bigDecimalService.get(100);

    if ( this.bigDecimalService.get(quantity).isLessThan(hundred)) {
      return;
    }

    this.block.start();

    this.haynesProService.getPurchaseLookupQuote(quantity)
    .then(( price : string ) => {
      this.quote.price = price;
    })
    .catch(( err ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }
}
